export function filterUnique<T = any>(array: T[]) {
  return array.filter((item, idx, source) => source.indexOf(item) === idx);
}